<app-genesys-wrapup-panel
  class="wrapup"
  [conversationId]="conversationId"
  [selectedWrapUp]="selectedWrapUp"
  [wrapUpCodes]="wrapUpCodes$ | async"
  [isWrapUpRequired]="isWrapUpRequired$ | async"
  [isConversationClosed]="(isConversationOpen$ | async) === false"
  [communicationType]="communicationTypes.Email"
  (selected)="selectWrapUp($event)"
  (submitted)="saveWrapUp($event)"
  (skipped)="skipWrapUp()"
  (togglePanel)="toggleWrapUp()"
>
</app-genesys-wrapup-panel>
